// @flow
import { connect } from 'react-redux';
import type { State } from '../../../types';
import { activeSectionSelector } from '../../../selectors/appSelectors';
import Sidebar from '../Sidebar';
import type { Props } from '../Sidebar';

const mapStateToProps = (state: State) => {
    const activeSection = activeSectionSelector(state);

    return {
        drawerOpen: Boolean(activeSection),
        activeSection: activeSection
    };
};

export default connect<Props, _, _, _, _, _>(mapStateToProps)(Sidebar);